<template>
  <div>
    <div class="boxView">
      <div class="van-hairline--bottom">
        <div class="alreadyArrive">提现-到账 {{detail.bankName}} ({{detail.cardNo}})</div>
        <div class="box-pirce">
          <span>￥</span>
          <span class="pirce">{{detail.money}}</span>
        </div>
      </div>
    </div>
    <div class="withdrawMessage">
      <div>提现时间</div>
      <div>{{detail.finishtime}}</div>
      <div>到账银行</div>
      <div>{{detail.bankName}}</div>
      <div>收款人</div>
      <div>{{detail.memberName}}</div>
      <div>交易单号</div>
      <div>{{detail.streamId}}</div>
    </div>
    <div class="tips">
      <p>温馨提示</p>
      <p>此页面说明提现业务受理成功，不代表资金已转入收款 账户，不作为收付方交易确认的最终依据。交易结果请 以账户实际入账为准。</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      money: "",
      index: 0,
      id: "",
    };
  },
  mounted() {
    this.detail = JSON.parse(this.$route.params.detail);
  },
};
</script>
<style lang="scss" scoped>
.boxView {
  padding: 0 16px;
  text-align: center;
  background-color: #fff;
}

.alreadyArrive {
  font-size: 17px;
  padding-bottom: 9px;
  padding-top: 23px;
}
.box-pirce {
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 25px;
}
.pirce {
  font-size: 40px;
  font-weight: bold;
}
.withdrawMessage {
  padding: 22px 16px 12px;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
}
.withdrawMessage div:nth-child(n) {
  padding-bottom: 10px;
  width: 30%;
  font-size: 15px;
  color: rgba(102, 102, 102, 1);
}
.withdrawMessage div:nth-child(2n) {
  width: 70%;
  padding-bottom: 10px;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
}
.tips {
  margin: 19px 23px 0 16px;
  p:first-child {
    font-size: 17px;
    font-weight: bold;
    color: #333333;
  }
  p:last-child {
    padding-top: 4px;
    font-size: 14px;
    color: #666666;
  }
}
</style>